export { default } from './Button';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Button/index.js
// module id = 48
// module chunks = 0